import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [
        // ##########################################
        // ################ HOME ####################
        // ##########################################
        {
            path: "/",
            component: require("../pages/index").default,
        },

        // ##########################################
        // ################ GALLERY ####################
        // ##########################################
        {
            path: "/galerija",
            component: require("../pages/gallery").default,
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js